import { useSelector } from "react-redux";
import { App } from "../redux/apps";
import { RootState } from "../redux/root";
import { Loadable } from "../util/loadable";
import { NETWORK_INFO } from "./constants";

function getURLForApp(app: App): string {
  const { auth_token, network } = app;
  const url = `${NETWORK_INFO[network].apiDomain}/v2/${auth_token}`;
  return url;
}

export function getHttpUrlForApp(app: App): string {
  return `https://${getURLForApp(app)}`;
}

export function getWebSocketUrlForApp(app: App): string {
  return `wss://${getURLForApp(app)}`;
}

export function getReferralUrlForApp(): string {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- FIXME
  const team = useSelector((rootState: RootState) => rootState.team.team);

  const referralTokenObject = Loadable.map(team, (t) => t.referral_token);
  const referralToken = referralTokenObject.value;
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- FIXME
  return `https://alchemy.com/?r=${referralToken}`;
}

export interface MailtoParams {
  email: string;
  subject: string;
  body?: string;
}

export function getMailtoUrl({ email, subject, body }: MailtoParams): string {
  return (
    `mailto:${email}` +
    `?subject=${encodeURIComponent(subject)}` +
    (body ? `&body=${encodeURIComponent(body)}` : "")
  );
}
